<template>
  <div class="login-body">
    <div class="back-btn">
      <el-button
        icon="el-icon-arrow-left"
        :style="{ boxShadow: '0px 2px 4px 2px rgba(129, 150, 180, 0.1)' }"
        @click="backHandle"
      >
        <span>回到官网</span>
      </el-button>
    </div>
    <div class="code-body">
      <div class="code-body-box">
        <div class="head">
          <div class="logo"><img :src="logoImg" alt="" /></div>
          <h4>法律实证分析平台</h4>
          <p>马上扫码，免费体验</p>
        </div>

        <div class="code" id="code" style="display:none;"></div>

        <div class="new_code"><img class="wechatcode-img" :src="wxCodeImg" alt="" /></div>

        <div class="tips">
          <span class="icon-big"><img :src="wxImg" alt=""/></span><span>微信登录</span>
          <p class="word-normal">请使用微信扫描二维码登录</p>
        </div>

        <div class="agreement">
          <p class="word-normal">登录成功即完成注册，代表同意<a @click="agreementVisiable = true">《用户协议》</a></p>
        </div>
      </div>
    </div>
    <div class="desc-body">
      <div class="img-body">
        <h3>让复杂的法律大数据</h3>
        <h2>深度分析变得简单高效</h2>

        <div class="img-box">
          <img :src="backgroundImg" />
        </div>
        <div class="description">
          <p>
            <span class="icon-big"><i class="iconfont iconshuju"></i></span>亿级法律数据随时使用
          </p>
          <p>
            <span class="icon-big"><i class="iconfont iconshujuweidu"></i></span>2万+研究数据标签
          </p>
        </div>
        <div class="description">
          <p>
            <span class="icon-big"><i class="iconfont iconjianmo"></i></span>支持简单统计和复杂建模
          </p>
          <p>
            <span class="icon-big"><i class="iconfont iconkeshihuatubiao"></i></span>丰富的可视化图表
          </p>
        </div>
      </div>
    </div>

    <el-dialog :visible="agreementVisiable" title="用户协议" @close="agreementVisiable = false">
      <div class="agreement-body">
        <h4>“小包公”用户注册服务协议</h4>
        <span
          >本服务协议是广东博维创远科技有限公司与您在协商一致的基础上，就“小包公”平台（以下简称“小包公”）及服务所订立的有效合约。
        </span>
        <p>一、服务内容</p>
        <div>
          <span
            >（一）广东博维创远科技有限公司在服务期限内授权用户按照本协议约定的方式使用“小包公”服务。用户在“小包公”点击“注册”按钮，即承认用户已阅读、理解本服务协议所有条款以及“小包公”所包含的各项指引、规则、政策、法律声明，并同意受其约束；且视为用户确认自己具有享受“小包公”服务、进行消费、签署合同等相应的权利能力和行为能力，能够独立承担法律责任。</span
          >
        </div>
        <div>
          <span
            >（二）用户注册的账号所有权归“小包公”所有，用户只有使用权。“小包公”享有在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭注销用户账户、
            清除或编辑内容或取消订单的权利。</span
          >
        </div>
        <div>
          <span
            >（三）用户在注册时应提供完整、详尽、真实的个人资料，若所提供的资料日后有变更，用户应及时登录账号进行更新。若用户在“小包公”留下的个人资料与事实不符，“小包公”可以停止向其继续提供产品和服务。当用户向“小包公”主张其拥有某账号时，若该账号在“小包公”的身份信息记录与用户的身份信息有任何不符，“小包公”有权不予认定该账号为该用户所有。</span
          >
        </div>
        <div>
          <span
            >（四）根据国家法律法规变化及网络运营需要，“小包公”可在不事先通知用户的情况下，修改本协议下的条款和条件或单独条款和条件。
            一旦“小包公”将这些修改后的条款和条件或单独条款和条件登载公示在“小包公”上即生效，并代替原来的协议。用户如继续使用本服务，
            则应被视为对修改后的条款和条件或单独条款和条件给予有效而不可撤消的同意。用户在使用本服务时，应定期查阅这些条款和条件。
          </span>
        </div>
        <p>二、授权范围及限制</p>
        <div><span>（一）授权使用：“小包公”及其所含资料仅限于您以参考为目的使用（统称为“授权使用”）。</span></div>
        <div><span>（二）授权限制：</span></div>
        <div style="padding-left:14px;">
          <span> 1、不得对“小包公”全部或部分资料进行再发行、转发、出版、转让、商业或其他开发。</span>
        </div>
        <div style="padding-left:14px;">
          <span>
            2、不得通过对“小包公”资料系统提取或分析而直接或间接创建或编纂任何产品或作品，包括但不限于专辑、汇编、数据库、目录、期刊、论文等。
          </span>
        </div>
        <div style="padding-left:14px;">
          <span> 3、不得转让、共用、分享“小包公”的账户，“小包公”账户具有唯一性。</span>
        </div>
        <div style="padding-left:14px;"><span> 4、不得利用该系统从事违法犯罪、违背公序良俗的活动。</span></div>
        <div><span>（三）声明</span></div>
        <div style="padding-left:14px;">
          <span>
            1、“小包公”出具的报告、意见或解答，系根据法律法规、大数据分析得出，仅供用户参考，不代表司法机关的观点、结论。</span
          >
        </div>
        <div style="padding-left:14px;">
          <span>
            2、“小包公”对所涉具体案件的结果不做承诺，用户以“小包公”出具的报告、意见或解答与最终结果不同引起的纠纷，“小包公”不承担任何法律责任。</span
          >
        </div>
        <div style="padding-left:14px;">
          <span>
            3、“小包公”对专家论证报告不承担任何责任，用户知悉并同意专家论证报告对相关案件结果并不存在必然的影响。</span
          >
        </div>
        <div style="padding-left:14px;">
          <span>
            4、“小包公”仅作为第三方平台，为律师用户及其他用户提供技术帮助，“小包公”对于用户采购的具体法律服务不作任何承诺，不承担责任。</span
          >
        </div>
        <div style="padding-left:14px;">
          <span>
            5、“小包公”所提供的搜索结果因数据更新、技术等相关原因，可能存在滞后、模糊、不准确、中断等情况，“小包公”对此不承担任何责任。</span
          >
        </div>
        <p>三、服务费用和服务期限</p>
        <div>
          <span
            >“小包公”注册不收取服务费用，部分功能的服务费用和服务期限将在订购协议或订购的系统页面中予以列明，用户可自行选择服务类型并按列明的价格予以支付。</span
          >
        </div>

        <p>四、“小包公”的的权利、义务</p>
        <div>
          <span>（一）“小包公”应在现有技术上维护平台服务的正常进行，并努力提升技术及改进技术，使服务更好进行。</span>
        </div>
        <div>
          <span
            >（二）“小包公”可能包含指向其他网站或资源的超链接。“小包公”对通过这些链接而访问到的任何第三方资料或资源的内容不承担任何责任。用户与第三方发生的任何交易均与“小包公”无关，请查阅该链接网站的条款和条件以及隐私政策。</span
          >
        </div>
        <div>
          <span
            >（三）在未经“小包公”明示许可的情况下，用户不得将账号信息或访问账号的其他方式提供给任何未经“小包公”授权的单位或个人。同时，用户应对所有使用您的账号信息对“小包公”的访问负责。如果用户的账号已经泄漏，丢失或被盗，或者用户认为有泄露、丢失和被盗风险，请务必马上联系“小包公”工作人员。</span
          >
        </div>
        <div>
          <span
            >（四）“小包公”的所有信息材料是在基于现状的情况下提供给用户的，“小包公”不做任何形式的承诺和保证，对于用户参考“小包公”内容做出的一切行为，“小包公”不承担任何责任。</span
          >
        </div>

        <p>五、用户的的权利、义务</p>
        <div>
          <span
            >（一）不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论。</span
          >
        </div>
        <div><span>（二）不得利用“小包公”从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动。</span></div>
        <div><span>（三）不得干扰“小包公”的正常运转，不得侵入“小包公”及国家计算机信息系统。</span></div>
        <div><span>（四）不得教唆他人从事本条所禁止的行为。 </span></div>
        <div><span>（五）不得利用在“小包公”注册的账户进行牟利性经营活动。 </span></div>
        <div><span>（六）不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容。</span></div>
        <div>
          <span
            >（七）“小包公”保有删除各类不符合法律政策或不真实的信息内容而无须通知用户的权利。若用户未遵守以上规定的，“小包公”有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。</span
          >
        </div>
        <div>
          <span
            >（八）禁止以任何目的在“小包公”平台使用网络爬虫或其他自动下载程序或设备，包括但不限于从“小包公”获取未公开的数据、他人邮寄或邮件地址、发布商业广告。</span
          >
        </div>

        <p>六、免责声明</p>
        <div>
          <span
            >（一）“小包公”仅为用户查询相关法律信息资料提供内容上的参考，如需正式引用，请核对官方正式文本。如使用“小包公”提供的信息影响到您所进行的法律事务，致使其出现了您预期以外的困难或结果，“小包公”不承担任何责任。</span
          >
        </div>
        <div>
          <span
            >（二）“小包公”有权随时对软件及数据库的功能、结构和内容进行添加或者删改，而无须事先通知用户，“小包公”及其工作人员或其他关联人，对包括疏忽或其他原因所造成的信息资料的任何不当之处，均不承担责任。</span
          >
        </div>
        <div>
          <span
            >（三）访问“小包公”查看并下载或以其他形式获取“小包公”的任何材料，与此有关的风险由用户自行承担，对于因下载任何材料而发生电脑系统的任何损毁或数据损失，自行承担责任。</span
          >
        </div>
        <div>
          <span
            >（四）“小包公”可能包含指向其他网站或资源的超链接。“小包公”对通过这些链接而访问到的任何第三方资料或资源不承担任何责任。用户与第三方发生的任何交易均与“小包公”无关。</span
          >
        </div>

        <p>七、知识产权</p>
        <div>
          <span
            >（一）“小包公”产品及其衍生品相关的所有资料及源代码的知识产权属于广东博维创远科技有限公司。“小包公”向用户提供的任何内容、技术或技术支持、软件、服务等的知识产权均属于广东博维创远科技有限公司所有。用户无权复制、传播、转让、许可或提供他人使用上述资源。否则广东博维创远科技有限公司将追究用户相应的责任。</span
          >
        </div>
        <div>
          <span
            >（二）“小包公”所使用和显示的商标、服务标识、商品名称和标志归广东博维创远科技有限公司所有。用户不得以任何目的复制、仿造或使用或与之整体或部分相似的任何标志。</span
          >
        </div>
        <div><span>（三）未经“小包公”书面授权，任何人不得建立本网站的镜像（包括全部和局部镜像）。</span></div>

        <p>八、信息安全及保密</p>
        <div>
          <span
            >（一）用户应自行诚信向“小包公”提供注册资料，用户同意其提交的注册信息均真实、准确、及时、详尽和完整，并不断更新注册资料。不含有任何违反国家法律、法规及中华人民共和国承认或加入的国际条约的内容，且您通过“小包公”所从事的一切活动都是合法、真实的，不侵害任何第三方的合法权益。否则，用户应承担因此引起的相应责任及后果，并且“小包公”保留终止用户使用服务并追究用户赔偿损失的权利。
          </span>
        </div>
        <div>
          <span
            >（二）用户在“小包公”进行购买活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，“小包公”将予以严格保密。
          </span>
        </div>
        <div>
          <span
            >（三）用户注册成功后，将产生账号和密码等账户信息。用户应谨慎合理的保存、使用其账号和密码。“小包公”将凭密码进行的所有活动视为用户直接的行为。
          </span>
        </div>
        <div>
          <span
            >（四）用户同意，“小包公”拥有通过邮件、短信、电话等形式，向在“小包公”注册、购买的用户发送订单信息、促销活动等告知信息的权利。
          </span>
        </div>
        <div>
          <span
            >（五）用户不得将在“小包公”注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。
          </span>
        </div>
        <div>
          <span
            >（六）用户使用“小包公”为任何第三方提供服务的，对于用户和第三方之间的纠纷，“小包公”将不承担任何责任。
          </span>
        </div>
        <div>
          <span
            >（七）用户同意，在需要进行司法协助时，“小包公”有权使用用户的注册信息、账号、密码等信息，登陆进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。</span
          >
        </div>

        <p>九、违约情形</p>
        <div>
          <span
            >（一）用户同意保障和维护“小包公”及其他用户的利益，如因用户违反有关法律、法规或本用户协议项下的任何条款而给“小包公”或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。</span
          >
        </div>
        <div>
          <span
            >（二）用户同意补偿广东博维创远科技有限公司及其关系企业、受雇人、及一切相关人员，因用户违反相关法律法规或本用户协议所产生之一切损害及责任。</span
          >
        </div>

        <p>十、争议解决</p>
        <div>
          <span
            >（一）凡因本协议而产生的争议，双方应友好协商解决。协商解决不成的，各方均同意将争议提交广州仲裁委员会网络仲裁解决，适用《中国广州仲裁委员会网络仲裁规则》。</span
          >
        </div>
        <div><span>（二）双方将以下手机号码或E-mail作为仲裁案件及接收另一方通知的电子送达地址：</span></div>
        <div><span>广东博维创远科技有限公司的联系方式：以工商登记信息为准。</span></div>
        <div><span>用户的联系方式：以用户在“小包公”绑定的信息为准。</span></div>

        <p>十一、送达</p>
        <div>
          <span
            >本用户协议项下所有的通知均可通过“小包公”平台重要页面公告、电子邮件等方式进行。该等通知于发送之日视为已送达收件人。</span
          >
        </div>

        <p>十二、其他</p>
        <div><span>（一）本协议自用户注册之时起生效。</span></div>
        <div>
          <span
            >（二）如本协议中的任何内容无论因何种原因完全或部分无效或不具有执行力，本协议的其余内容仍应有效并且对协议各方有约束力。</span
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible="addUserInfo"
      :close-on-click-modal="false"
      :show-close="false"
      width="500px"
      custom-class="normal-dialog full-dialog info-dialog hide-header-dialog"
    >
      <div class="info-panel">
        <div class="info-img">
          <img :src="infoHeadImg" />
        </div>
        <div class="info-img-desc">
          <h3>完善资料<span>免费试用</span></h3>
          <p class="word-middle">享受前所未有的法律科研新体验</p>
        </div>

        <div class="info-form">
          <el-form @submit.native.prevent label-position="top">
            <el-form-item>
              <span slot="label" class="word-normal">手机号<span :style="{ color: '#F62733' }">*</span></span>
              <el-input :maxlength="11" placeholder="请输入手机号" v-model="model.tel"></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="word-normal">验证码 <span :style="{ color: '#F62733' }">*</span></span>
              <el-input :maxlength="6" placeholder="请输入验证码" v-model="model.code">
                <template slot="append">
                  <a
                    :style="{ color: '#1991FB', cursor: !disabled ? 'pointer' : 'inherit' }"
                    :disabled="disabled"
                    @click="getSmsCode"
                    >{{ verification }}</a
                  >
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="word-normal">姓名<span :style="{ color: '#F62733' }">*</span></span>
              <el-input placeholder="请填写姓名" v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="word-normal">机构<span :style="{ color: '#F62733' }">*</span></span>
              <el-input placeholder="请填写机构名称（例如学校、研究所、企业）" v-model="model.org"></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="word-normal">职业 <span :style="{ color: '#F62733' }">*</span></span>
              <el-input placeholder="请输入职业" v-model="model.profession"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addInfoHandle" :style="{ width: '100%' }">立即试用</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import logoImg from '../assets/img/red-logo.png';
import wxImg from '../assets/img/wechat.png';
import backgroundImg from '../assets/img/login-background.png';
import infoHeadImg from '@/assets/img/info-head.png';
import loadFailImg from '@/assets/img/white.png';

import { services } from '@/service';
import qs from 'qs';

export default {
  data() {
    return {
      logoImg,
      wxImg,
      backgroundImg,
      infoHeadImg,
      agreementVisiable: false,
      disabled: false,
      isSendCode: false,
      verification: '获取验证码',
      model: {
        tel: '',
        profession: '',
        org: '',
        name: '',
        code: ''
      },
      loginQrcodeKey: '',
      wxCodeImg: loadFailImg,
      wxCodeMarkFlag: false,
      addUserInfo: false,
      wxTimeoutController: 0,
      codeTimeoutController: 0
    };
  },

  beforeDestroy() {
    if (this.wxTimeoutController) {
      clearInterval(this.wxTimeoutController);
    }
    if (this.codeTimeoutController) {
      clearInterval(this.codeTimeoutController);
    }
  },

  mounted() {
    this.getWxLoginqrCode();
  },

  methods: {
    backHandle() {
      if (process.env.NODE_ENV === 'production') {
        window.location.href = window.location.origin;
      } else {
        this.$router.replace({ name: 'login', query: this.$route.query });
      }
    },
    // 获取微信登录 qrCode
    async getWxLoginqrCode() {
      const res = await services.authriozation.getWxQrCode({
        regUrl: location.href
      });

      if (res && res.ticket) {
        this.wxCodeMarkFlag = false;
        this.loginQrcodeKey = res.key;
        const ticket = res.ticket;

        this.getWxLoginCode(ticket);
      }
    },
    // 生成微信登录二维码
    getWxLoginCode(ticket) {
      if (!ticket) return;

      this.wxCodeImg = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${ticket}`;

      let key = 0;
      if (this.wxTimeoutController) {
        clearInterval(this.wxTimeoutController);
      }
      const timer = setInterval(() => {
        this.checkWxLoginCode(timer, key++);
      }, 2000);
      this.wxTimeoutController = timer;
    },
    // 验证微信登录二维码
    async checkWxLoginCode(timer, key) {
      // 超过一分钟为验证成功，重新生成二维码
      if (key >= 30) {
        clearInterval(timer);
        this.wxTimeoutController = 0;

        this.getWxLoginqrCode();

        return;
      }

      const res = await services.authriozation.getWxOfficialLogin(this.loginQrcodeKey);

      if (res.is_login == '0') {
        clearInterval(timer);
        this.wxTimeoutController = 0;
      } else if (res.is_login == '2') {
        clearInterval(timer);
        this.wxTimeoutController = 0;

        try {
          this.$store.dispatch('setToken', res.token);
          await this.$store.dispatch('getUserInfo');
          await this.$store.dispatch('getOrders');
          this.loginAfterHandle();
        } catch (err) {
          if (err.message === '未绑定手机号') {
            this.$message.warning('请绑定手机号');
            this.addUserInfo = true;
          } else {
            this.$error(err);
            this.$store.dispatch('logout', { replaceToLogin: false, sendEvent: true });
            this.getWxLoginqrCode();
          }
        }
      }
    },
    async getSmsCode() {
      try {
        if (!this.model.tel) {
          this.isSendCode = true;
          this.$message({ type: 'warning', message: '请输入正确的手机号码' });
          return;
        }
        if (this.verification !== '重新发送' && this.verification !== '获取验证码') {
          return;
        }
        if (this.disabled) {
          return;
        }
        var time = 60;
        if (this.codeTimeoutController) {
          clearInterval(this.codeTimeoutController);
        }
        var timer = setInterval(() => {
          time--;
          this.verification = `${time}s`;
          if (time == 0) {
            clearInterval(timer);
            this.codeTimeoutController = 0;
            timer = null;
            this.verification = '重新发送';
            this.disabled = false;
          }
        }, 1000);
        this.codeTimeoutController = timer;

        this.disabled = true;
        await services.authriozation.getSmsCode({ tel: this.model.tel });
      } catch (err) {
        this.$error(err);
      }
    },
    async addInfoHandle() {
      if (!this.model.name) {
        this.$message({ type: 'warning', message: '请输入正确的姓名' });
        return;
      }

      if (!this.model.tel) {
        this.isSendCode = true;
        this.$message({ type: 'warning', message: '请输入正确的手机号码' });
        return;
      }

      if (this.isSendCode && !this.model.code) {
        this.$message({ type: 'warning', message: '请输入正确的验证码' });
        return;
      }

      if (!this.model.org) {
        this.$message({ type: 'warning', message: '请填写机构名称（例如学校、研究所、企业）' });
        return;
      }

      if (!this.model.profession) {
        this.$message({ type: 'warning', message: '请填写职业' });
        return;
      }

      try {
        await this.$store.dispatch('valid', this.model);
        this.addUserInfo = false;
        await this.$store.dispatch('getUserInfo');
        await this.$store.dispatch('getOrders');
        this.loginAfterHandle();
      } catch (err) {
        this.$error(err);
        this.$store.dispatch('logout', { replaceToLogin: false, sendEvent: true });
        this.getWxLoginqrCode();
      }
    },
    loginAfterHandle() {
      const { redirect_name: redirectName = '', redirect_query: redirectQuery = '' } = this.$route.query;
      if (redirectName) {
        const query = qs.parse(decodeURIComponent(redirectQuery));
        this.$router.replace({ name: redirectName, query });
      } else {
        this.$router.replace({ name: 'home' });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.login-body {
  width: 100%;
  display: flex;

  .back-btn {
    position: absolute;
    top: 15px;
    left: 20px;
    z-index: 10;
  }
  .code-body {
    width: 720px;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    text-align: center;
    position: relative;
    .head {
      .logo {
        width: 120px;
        margin: 0 auto;
        img {
          width: 100%;
          display: block;
        }
      }
      h4 {
        font-size: 26px;
        color: #001529;
        margin: 30px 0 10px 0;
      }
      p {
        font-size: 16px;
        margin-top: 20px;
        font-weight: 300;
        color: #77839e;
      }
    }

    .code,
    .new_code {
      width: 240px;
      height: 240px;
      margin: 30px auto;
      img {
        width: 100%;
        display: block;
      }
    }

    .tips {
      .icon-big {
        width: 24px;
        margin: 0 4px 4px 0;
      }
      span {
        color: #2c3443;
        font-size: 18px;
      }
      p {
        color: #77839e;
        margin-top: 10px;
      }
    }

    .agreement {
      position: absolute;
      bottom: 30px;
      width: 100%;
      left: 5px;
      color: #77839e;
      a {
        color: #1991fb;
      }
    }
  }

  .desc-body {
    flex: 1;
    background: linear-gradient(180deg, #0c93f2 0%, #0646e3 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    color: #fff;
    .img-box {
      width: 560px;
      margin: 0 auto 35px auto;
    }
    img {
      display: block;
      width: 100%;
    }
    h2 {
      font-size: 42px;
      margin-bottom: 40px;
    }
    h3 {
      font-size: 28px;
      font-weight: 300;
      margin-bottom: 20px;
    }
    .description {
      display: flex;
      justify-content: space-between;
      margin-top: 24px;
      .icon-big {
        margin: 0 4px 0 0;

        .iconfont {
          font-size: 22px;
        }
      }
    }
  }

  .agreement-body {
    line-height: 22px;
    max-height: 600px;
    overflow-y: auto;
    padding: 20px 15px;
    h4 {
      font-size: 18px;
      color: #222;
      margin-bottom: 20px;
    }
    span {
      font-size: 14px;
      color: #666;
    }
    p {
      font-size: 16px;
      color: #222;
      margin: 15px 0;
    }
  }
}

@media screen and (max-width: 1440px) {
  .login-body .code-body {
    width: 580px;
  }
}

.info-panel {
  background-color: #3069e8;
  .info-img {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      display: block;
    }
  }

  .info-img-desc {
    position: absolute;
    left: 30px;
    top: 40px;
    color: #fff;
    line-height: 32px;
    h3 {
      font-size: 22px;
      font-weight: 300;
    }
  }
  .info-form {
    padding: 30px;
    background: #fff;
  }
}
</style>
